import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';

export default function ({ isTest, onClickCheckBox, testEmailError, testEmail, onChangeField }) {
	return (
		<React.Fragment>
			<FormControlLabel
				control={<Checkbox
					color="primary"
					checked={isTest}
					onChange={() => onClickCheckBox('isTest')}
					style={{ block: { maxWidth: 250 }, checkbox: { marginBottom: 16, } }}
				/>}
				label="É uma notificação de teste?"
			/>

			<br />
			{isTest &&
				<React.Fragment>
					<InputLabel>
						Email de teste
					</InputLabel>
					<TextField
						error={testEmailError !== '' && testEmailError !== null}
						helperText={testEmailError}
						value={testEmail}
						onChange={event => onChangeField('testEmail', event.target.value)}
						fullWidth
					/>
					<br />
					<br />
				</React.Fragment>
			}
		</React.Fragment>
	);
}


// WEBPACK FOOTER //
// ./src/components/notification/fields/IsTestField.js